export function generateIconWithLabel (iconUrl, labelText, labelColor = "black", labelFont = "bold 16px Roboto") {
    return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = iconUrl;
        
        img.onload = () => {
            const canvas = document.createElement('canvas');
            
            canvas.width = img.width || 40; 
            canvas.height = img.height || 40;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            ctx.font = labelFont; 
            ctx.fillStyle = labelColor;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(labelText, canvas.width / 2, canvas.height / 2);

            resolve(canvas.toDataURL());
        };
    });
};